import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { connect } from 'react-redux';
import {
  useLocation,
  useParams
} from "react-router-dom";
import ScaleLoader from 'react-spinners/ScaleLoader';
import { setAuthInfo, setBookmarkList, setExhibitorList, setLoading } from './actions/main';
import { setSearchInputValue, setSearchKeySelect, setSearchOptions, setSearchPulldownValue } from './actions/searchbox';
import { setCustomStyles, setOpenCompanyProfile, setOpenLogin } from './actions/ui';
import './App.css';
import { ESHOW_URL } from './config.js';
import { getTokenCookie, getTokenPlanner, getUrlToken, setCookie } from './utils/Common';
import { applySorting } from './utils/sortUtils';
import ExhibitorCard from './viewer/component/ExhibitorCard';
import Footer from './viewer/component/Footer.js';
import LeftProfile from './viewer/component/LeftProfile';
import SearchBox from './viewer/component/SearchBox.js';
import SortControl from './viewer/component/SortControl.js';
import ToolBox from './viewer/ToolBox';
function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

function paginate(array, page_size, page_number) {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

function Index(props) {
  const { id1, id2, id3, id4, id5 } = useParams();
  let query = useQuery();
  const [data, setData] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [page, setPage] = React.useState(1);
    const [filteredItems, setFilteredItems] = useState([])
  const [boothFileList, setBoothFileList] = useState([]);
  const page_size = 16;
  
  let standardSearchOptions = props.searchboxSearchOptions?.STANDARD ?? []
  let keySelect = props.searchboxKeySelect
  let pulldownValue = props.searchboxPulldownValue
  let searchInputValue = props.searchboxInputValue
  var selectedAdvancedFilterOptions = props.searchboxSelectedAdvancedFilterOptions
  let sortBy = props.searchboxSortBy
  let sortOrder = props.searchboxSortOrder

  const useStyles = makeStyles((theme) => ({
    searchBtn:{
      backgroundColor: props.ui?.customStyles?.['search-button-bg-color']?(props.ui?.customStyles['search-button-bg-color']+"!important"):'#1565c0',
      color: props.ui?.customStyles?.['search-button-label-color']?(props.ui?.customStyles['search-button-label-color']+"!important"):'#1565c0',
    },
    bubble:{
      color:props.ui?.customStyles?.['bubble-label-color']?(props.ui?.customStyles['bubble-label-color']+"!important"):'white',
      backgroundColor:props.ui?.customStyles?.['bubble-bg-color']?(props.ui?.customStyles['bubble-bg-color']+"!important"):'#1565c0',
    }
  }));
  const classes = useStyles();

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const fetchData = ()=>{
    props.setLoading(true)
    var token = getTokenCookie();   
    try{     
        var _token = getTokenPlanner();
        if(_token){
          token = _token
        }
    }
    catch(e){
      console.log("token parse", e)
    }
    var url = `${ESHOW_URL()}?method=getFeatured&featured=yes`
    const options = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }   

    axios.get(url, options).then(res=>{
        const result = res.data;
        if(result.SUCCESS){  
          props.setExhibitorList(result)
          props.setSearchOptions(result.SEARCH)      
          if(result.EXHIBITORS){
            var boothList = [];
            for(var i = 0; i< result.EXHIBITORS.length; i++){
              var item = result.EXHIBITORS[i]
              if(!item?.SETUP?.LIST_PENDING_EXHIBITORS && item.STATUS == 2)
                continue;
              boothList.push(item)
            }            
            setData(boothList)
            setFilteredItems(boothList)
          }
        }
        else{
          setData([])
          setFilteredItems([])
        }
        setDataFetched(true)
        props.setLoading(false)
    }).catch(error => {
      props.setLoading(false)
    })  
  }

  useEffect(() => {
    props.setOpenCompanyProfile(false)
  }, [])
  
  const queryString = window.location.search;
  var urlToken = getUrlToken()
  useEffect(() => {
    if(props.urlToken){
        var public_token = `/${id1}`
        if(id2){
          public_token = `${public_token}/${id2}`
        }
        if(id3){
          public_token = `${public_token}/${id3}`
        }
        if(id4){
          public_token = `${public_token}/${id4}`
        }
        if(id5){
          public_token = `${public_token}/${id5}`
        }
        setCookie('V3PUBLICMAP', public_token)
    }
    document.getElementsByTagName("body")[0].style.overflowY='scroll'
    fetchBookmarkList()
    fetchData()
    fetchboothlist()
  }, [props.main[`planner-${urlToken}`], id5, id4, id3, id2, id1])
  

  useEffect(() => {
    if(data.length)
      doSearch()
  }, [data])

  
  useEffect(() => {
    if(data.length)
      debouncedSearch()
  }, [keySelect, pulldownValue, searchInputValue, selectedAdvancedFilterOptions])  
  
  const doSearch=(value)=>{    
    setPage(1);
    var keyword = null
    let searchOption = getSearchOption(keySelect)
    if(value){
      keyword = value
    }
    else{
      if(searchOption && searchOption.TYPE == 'pulldown'){
        keyword = pulldownValue
      }
      else{
        keyword = searchInputValue
      }
    }
    if(!keyword) keyword = ''
    keyword = `${keyword}`
    var filteredItems = data;
    if((keyword == "" || keyword == '""' || !keyword) && selectedAdvancedFilterOptions?.length === 0){
      setFilteredItems(filteredItems)
      return;
    }
    if(keyword && keyword.trim() !== '') {
      filteredItems = data.filter((item)=>{
        var str = ''
        if(keySelect == "company_description") {
          str = `${item.DESCRIPTION?item.DESCRIPTION:''}`
          return (str.toLowerCase().includes(keyword.toLowerCase()))
        }
        else if(keySelect == "exhibitor_name"){
          str = `${item.COMPANY_NAME?item.COMPANY_NAME:''}`
          return (str.toLowerCase().includes(keyword.toLowerCase()))
        }
        else if(keySelect == "Product Categories"){
          var categories = item.CATEGORY;
          var keys = [];
          for(var i = 0; i< categories?.length; i++){
            keys.push(categories[i].ANSWER_KEY)
          }
          return (keys?.includes(keyword))
        }          
        else if(keySelect == "booth_number"){
          str = `${item.BOOTHS?item.BOOTHS:''}`
          return (str.toLowerCase().includes(keyword.toLowerCase()))
        }
        else if(keySelect == "map_name"){
          str = `${item.MAP_NAME?item.MAP_NAME:''}`
          return (str.toLowerCase().includes(keyword.toLowerCase()))
        }
        else if(keySelect == "state"){
          str = `${item.STATE?item.STATE:''}`
          return (str.toLowerCase()==(keyword.toLowerCase()))
        }
        else if(keySelect == "country"){
          str = `${item.COUNTRY?item.COUNTRY:'us'}`
          return (str.toLowerCase()==(keyword.toLowerCase()))
        }
        else if(keySelect == 'Featured Exhibitors'){
          str = `${item.FEATURED?item.FEATURED:''}`
          return (str.toLowerCase().includes(keyword.toLowerCase()))
        }
        else if(keySelect == "Region of Services"){
          var categories = item.CATEGORY;
          var keys = [];
          for(var i = 0; i< categories?.length; i++){
            keys.push(categories[i].ANSWER_KEY)
          }
          return (keys?.includes(keyword))
        }     
        else if(keySelect == "Service Specialty"){
          var categories = item.CATEGORY;
          var keys = [];
          for(var i = 0; i< categories?.length; i++){
            keys.push(categories[i].ANSWER_KEY)
          }
          return (keys?.includes(keyword))
        }             
        else{
          var categories = item.CATEGORY;
          var keys = [];
          for(var i = 0; i< categories?.length; i++){
            keys.push(categories[i].ANSWER_KEY)
          }
          return (keys?.includes(keyword))
        }
      })      
    }

    if(selectedAdvancedFilterOptions?.length){
      let selectedFilter = selectedAdvancedFilterOptions[0]['key']

      if(selectedFilter?.includes("Region of Services")){
        filteredItems = filteredItems.filter((item)=>{
            var categories = item.CATEGORY;
            var keys = [];
            for(var i = 0; i< categories?.length; i++){
              keys.push(categories[i].ANSWER_KEY)
            }
            for(var i = 0; i < selectedAdvancedFilterOptions?.length; i++){
              if(keys?.includes(selectedAdvancedFilterOptions[i]['value'])){
                return true;
              }
            }
            return false
        })
      }     
      else if(selectedFilter?.includes("Service Specialty")){
        filteredItems = filteredItems.filter((item)=>{
          var categories = item.CATEGORY;
          var keys = [];
          for(var i = 0; i< categories?.length; i++){
            keys.push(categories[i].ANSWER_KEY)
          }
          for(var i = 0; i < selectedAdvancedFilterOptions?.length; i++){
            if(keys?.includes(selectedAdvancedFilterOptions[i]['value'])){
              return true;
            }
          }
          return false
        })
      }  
      else {
        filteredItems = filteredItems.filter((item)=>{
          var categories = item.CATEGORY;
          var keys = [];
          for(var i = 0; i< categories?.length; i++){
            keys.push(categories[i].ANSWER_KEY)
          }
          for(var i = 0; i < selectedAdvancedFilterOptions?.length; i++){
            if(keys?.includes(selectedAdvancedFilterOptions[i]['value'])){
              return true;
            }
          }
          return false
        })
      }           
    }
    
    setFilteredItems(filteredItems)    
    // let newUrl = `${props.main.authInfo.tokenInfo?.ESHOW_PATH}/${searchOption.ID}/${keyword}`;
    // window.history.pushState(null, '', newUrl);
  }
  
  const debouncedSearch = debounce(doSearch, 300);

  const getSearchOption = (value)=>{
    if (!value) return false;
    for(var i = 0; i < standardSearchOptions?.length; i++){
      if(standardSearchOptions[i].ID == value){
        return standardSearchOptions[i]
      }
    }
    return false
  }

  const fetchBookmarkList = ()=>{
  { 
      try{
        var token =  getTokenPlanner();
        if(token){
          var url = `${ESHOW_URL()}?method=getPlanner`
          const options = {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }  
          axios.get(url, options).then(res=>{
              const result = res.data;
              if(result.SUCCESS){
                props.setBookmarkList(result.BOOKMARKS)
              }
              else{

              }
          }).catch(error => {
          })  
        }
      }
      catch(e){
        console.log(e)
      }
    }
  }

  // Stable ref for doBookmark deps.
  const callBookmarkApi = useCallback(
    async (exhibitor, value) => {
      const _token = getTokenPlanner();
      let BOOKMARKS = props.main.bookmarkList ? props.main.bookmarkList : [];
      if (value) {
        BOOKMARKS = [
          ...BOOKMARKS,
          {
            COMPANY_NAME: exhibitor?.COMPANY_NAME ? exhibitor.COMPANY_NAME : '',
            NOTES: '',
            STATUS: '',
            BOOTHS: exhibitor.BOOTHS,
            EXHIBITOR_KEY: exhibitor?.EXHIBITOR_KEY ? exhibitor.EXHIBITOR_KEY : '',
          },
        ];
      } else {
        BOOKMARKS = BOOKMARKS.filter(
          (item) => `${item.EXHIBITOR_KEY}` !== `${exhibitor.EXHIBITOR_KEY}`
        );
      }
      props.setBookmarkList(BOOKMARKS);
      const postData = { SUCCESS: true, BOOKMARKS };
      const options = {
        body: '[{"company:","test"}]',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${_token}`,
      };
      const url = `${ESHOW_URL()}?method=putPlanner`;
      axios.post(url, JSON.stringify(postData), options).then(async (res) => {
        const result = res.data;
        if (result.SUCCESS != true) {
          props.setOpenSnack(true);
          props.setSnackMsg(result.MESSAGE ? result.MESSAGE : 'Failed to save bookmark');
        }
      }).catch(() => {});
    },
    [
      props.main.bookmarkList,
      props.setBookmarkList,
      props.setOpenSnack,
      props.setSnackMsg,
    ]
  );

  const fetchboothlist=async (save_id=false)=>{   
    var url = `${ESHOW_URL()}?method=getMaps`;
    const options = {
      headers: {
        'Authorization': `Bearer ${getTokenCookie()}`
      }
    } 
    axios.get(url, options).then(res=>{
      setBoothFileList(res.data)
    }).catch(error => {
    })      
  }

  // Stable doBookmark ref; fixes setData (was this.setData).
  const doBookmark = useCallback(
    (exhibitor) => {
      if (!exhibitor) return;
      try {
        const _token = getTokenPlanner();
        if (props.role != 'admin' && (!_token || !_token)) {
          props.setOpenLogin(true);
          return;
        }
        const tmp = [...data];
        for (let i = 0; i < tmp.length; i++) {
          if (tmp[i].EXHIBITOR_KEY == exhibitor.EXHIBITOR_KEY) {
            tmp[i].BOOKMARKED = !tmp[i].BOOKMARKED;
            callBookmarkApi(exhibitor, tmp[i].BOOKMARKED);
          }
        }
        setData(tmp);
      } catch (e) {}
    },
    [data, callBookmarkApi, props.role, props.setOpenLogin]
  );

  var banner = props.main.showSetup?.PUBLIC?.HEADER_BANNER;
  if(banner == "undefined") banner = null
  var sales_bookmarks_show = true
  if(props.main.showSetup?.PUBLIC?.BOOKMARKS == 'hide'){
    sales_bookmarks_show = false
  }

  // Memoize sorted + paginated list.
  const outputItems = useMemo(
    () => applySorting(filteredItems, sortBy, sortOrder, true),
    [filteredItems, sortBy, sortOrder]
  );
  const pageData = useMemo(
    () => paginate(outputItems, page_size, page),
    [outputItems, page_size, page]
  );

  return (
    <Box id="xhbt-main-container" className="App Client">
      <ToolBox {...props}/>
      <Box className="xhbt-data-box" style={{maxWidth: 1240, margin:'64px auto', paddingLeft: 10, paddingRight:10, marginTop:(banner && banner != ''?(150+64):64)}}>
        <Box textAlign={'center'}>
          <SearchBox/>
        </Box>
        {/* Sort Control */}
        <Box mt={1} mb={1}>
          <SortControl align="right" />
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            {/* Stable list key */}
            {
              pageData.map((item, index)=>{
                return(
                  <Grid key={item.EXHIBITOR_KEY ?? index} item xs={12} sm={6} md={4} lg={3}>
                    <ExhibitorCard item={item} boothFileList={boothFileList} setKeySelect={props.setSearchKeySelect} setPulldownValue={props.setSearchPulldownValue} doBookmark={doBookmark}/>
                  </Grid>
                )
              })
            }
            
            {
              (!outputItems || outputItems.length == 0) && dataFetched && 
              <Box style={{textAlign:'center', width:'100%'}}>
                <p>No Featured Exhibitor Found.</p>
              </Box>
            }
          </Grid>
        </Box>
      </Box>
      <Box mt={3} mb={8}>
        <Stack spacing={2}>
          <Pagination variant="outlined" shape="rounded" style={{justifyContent:'center'}} count={Math.ceil(outputItems.length/page_size)} color="primary"  page={page} onChange={handleChangePage}/>
        </Stack>
      </Box>
      <Footer/>
      <LeftProfile groupOptions = {[]}/>
      {props.ui?.customStyles?.['loaded'] &&
      <LoadingOverlay
            active={props.main.loadingFlag}
            fadeSpeed = {100}
            styles={{
                overlay: (base) => ({
                ...base,
                fontSize:'18px',
                color: 'rgb(5, 37, 51)',
                // background: 'rgb(229 229 229 / 92%)',
                background: 'transparent',
                position:'fixed',
                top: '49px',
                zIndex:1000000000
                })
            }}
            spinner = {<ScaleLoader color={props.ui?.customStyles?.['spinner-color']?props.ui?.customStyles['spinner-color']:'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
            // spinner
            // text='Loading ...'
            >
        </LoadingOverlay> 
        }
    </Box>
  );
}


// Subscribe only to searchbox fields used here.
const mapStateToProps = (state) => {
  const sb = state.searchbox;
  return {
    main: state.main,
    booth_history: state.booth_history.present,
    ui: state.ui,
    cart: state.cart,
    searchboxSearchOptions: sb.searchOptions,
    searchboxKeySelect: sb.searchKeySelect,
    searchboxPulldownValue: sb.searchPulldownValue,
    searchboxInputValue: sb.searchInputValue,
    searchboxSelectedAdvancedFilterOptions: sb.selectedAdvancedFilterOptions,
    searchboxSortBy: sb.sortBy,
    searchboxSortOrder: sb.sortOrder,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setCustomStyles: data=>dispatch(setCustomStyles(data)),
      setAuthInfo:  data=>dispatch(setAuthInfo(data)), 
      setLoading:  data=>dispatch(setLoading(data)),
      setBookmarkList:  data=>dispatch(setBookmarkList(data)),
      setOpenLogin: value=>dispatch(setOpenLogin(value)) ,
      setOpenCompanyProfile:  data=>dispatch(setOpenCompanyProfile(data)),
      setExhibitorList:  data=>dispatch(setExhibitorList(data)),
      setSearchKeySelect:  data=>dispatch(setSearchKeySelect(data)),
      setSearchPulldownValue:  data=>dispatch(setSearchPulldownValue(data)),
      setSearchInputValue:  data=>dispatch(setSearchInputValue(data)),
      setSearchOptions:  data=>dispatch(setSearchOptions(data))
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
